import { KycCompletionStatus } from "../../store/store.model";
export const kycWarningTextsPath = 'pages.dashboard.kycWarning';
export function getKycWarning(worksAt, wasKYBApprovedDuringLast5Minutes, kycWarningTexts) {
  const {
    kycCompletionStatus
  } = worksAt || {};
  if (kycCompletionStatus === KycCompletionStatus.CompletedWithFutureRequirements) {
    return {
      testId: 'kyc-future-requirements',
      text: kycWarningTexts.message()
    };
  } else if (kycCompletionStatus === KycCompletionStatus.Incomplete && !wasKYBApprovedDuringLast5Minutes) {
    return {
      testId: 'onboarding-kyc-error',
      text: kycWarningTexts.message()
    };
  } else {
    return null;
  }
}